jQuery(document).ready(function ($) {

    var author_review_header = 'author_review_header';

    $('.author-review-header__articles').each(function () {
        var $articles = $(this);
        var $list = $articles.find('.author-review-header__article-list');

        if (!$list.length) {
            return;
        }

        function load(page) {
            if ($articles.hasClass('is-loading')) {
                return;
            }

            var maxPages = parseInt($articles.data('max-pages'), 10) || 1;

            if (page < 1 || page > maxPages || page === parseInt($articles.data('paged'), 10)) {
                return;
            }

            $articles.addClass('is-loading');

            $.ajax({
                method: 'POST',
                url: script_object.ajax_url,
                dataType: 'json',
                data: {
                    action: author_review_header,
                    function: 'load_articles',
                    author: $articles.data('author'),
                    post_type: $articles.data('post-type'),
                    limit: $articles.data('limit'),
                    paged: page
                },
                success: function (response) {
                    if (!response || !response.success) {
                        return;
                    }

                    $list.html(response.data.data);
                    $articles.find('.author-review-header__pagination').replaceWith(response.data.pagination);
                    $articles.data('paged', response.data.paged).attr('data-paged', response.data.paged);
                    $articles.data('max-pages', response.data.max_num_pages).attr('data-max-pages', response.data.max_num_pages);

                    $('html, body').animate({
                        scrollTop: $articles.offset().top - 24
                    }, 200);
                },
                complete: function () {
                    $articles.removeClass('is-loading');
                }
            });
        }

        $articles.on('click', '.author-review-header__page', function () {
            var page = parseInt($(this).data('page'), 10);

            if (!isNaN(page)) {
                load(page);
            }
        });
    });
});
